import React, { useState } from 'react';
import './client-footer.css';
import { ClientService } from '../../../../services/clientService';

function FeedbackPopup({ onClose, onSubmit, selectedFeedback, onFeedbackChange, commentText, setCommentText }) {

  return (
    <div className="feedback-popup-overlay">
      <div className="feedback-popup">
        <button className="feedback-close-popup" onClick={onClose}>
          &times;
        </button>
        <div className="feedback-header">
          <h2>Your Feedback Is Important to Us</h2>
          <p>Thank you! We read every feedback we get and take it very seriously.</p>
        </div>
        <form className="feedback-form" onSubmit={onSubmit}>
          <div className='feedback-qn'>
            How  do you feel about your visit on the app today ?
          </div>
          <div className="feedback-emojis">
            {[
              { value: "poor", emoji: "😞", label: "Poor" },
              { value: "unhappy", emoji: "😟", label: "Unhappy" },
              { value: "apathy", emoji: "😐", label: "Apathy" },
              { value: "happy", emoji: "😊", label: "Happy" },
              { value: "love", emoji: "😍", label: "Love" },
            ].map(({ value, emoji, label }) => (
              <label key={value}>
                <input
                  type="radio"
                  name="feedback"
                  value={value}
                  checked={selectedFeedback === value}
                  onChange={onFeedbackChange}
                />
                <span>{emoji}</span>
                <div className="emoji-text">{label}</div>
              </label>
            ))}
          </div>
          <div className='comments-qn'>Would you like to share something with us?</div>

          <textarea
            name="comments"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            placeholder="Text here"
          />

          <div className="feedback-buttons">
            <button type="button" onClick={onClose}>
              Cancel
            </button>
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ClientFooter() {
  const [isFeedbackOpen, setFeedbackOpen] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState("");
  const [commentText, setCommentText] = useState("");
  const [isFeedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');


  const emojiMap = {
    poor: 1,
    unhappy: 2,
    apathy: 3,
    happy: 4,
    love: 5,
  };

  const openFeedback = () => setFeedbackOpen(true);
  const closeFeedback = () => setFeedbackOpen(false);

  const handleNavigation = (path, section) => {
    if (!sessionStorage.getItem("initialScrollPosition")) {
      sessionStorage.setItem("initialScrollPosition", window.scrollY);
    }
    sessionStorage.setItem("scrollPosition", window.scrollY);
    window.location.href = `${path}?section=${section}`;
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedFeedback) {
      setErrorMessage("Please select a feedback option.");
      return;
    }

    const payload = {
      rank: emojiMap[selectedFeedback],
      message: commentText.trim()
    };

    try {
      await ClientService.submitClientFeedback(payload);
      setFeedbackSubmitted(true);
      closeFeedback();
    } catch (err) {
      console.error("Error submitting feedback", err);

      const errorMessage = err?.response?.data?.message || "";

      if (errorMessage.includes("Duplicate entry")) {
        setErrorMessage("You've already submitted your feedback. Thank you!");
      } else {
        setErrorMessage("Something went wrong. Please try again later.");
      }
    }

  };


  const handleFeedbackChange = (event) => {
    setSelectedFeedback(event.target.value);
  };

  return (
    <div className="client-footer">
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {isFeedbackOpen && (
        <FeedbackPopup
          onClose={closeFeedback}
          onSubmit={handleSubmit}
          selectedFeedback={selectedFeedback}
          onFeedbackChange={handleFeedbackChange}
          commentText={commentText}
          setCommentText={setCommentText}
        />
      )}

      {isFeedbackSubmitted && (
        <div className="feedback-thankyou">
          <div className="thankyou-message">
            <h3>Thank you for your feedback!</h3>
            <button
              className="thankyou-ok-button"
              onClick={() => setFeedbackSubmitted(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div className="client-footer-links">
        <a className="client-footer-links-a" onClick={() => handleNavigation("/policy", "privacy")}>
          Privacy Policy
        </a>
        <span>|</span>
        <a className="client-footer-links-a" onClick={() => handleNavigation("/policy", "terms")}>
          Terms & Conditions
        </a>
        <span>|</span>
        <a href="/feedback" onClick={(e) => { e.preventDefault(); openFeedback(); }}>
          Feedback
        </a>
      </div>
      <span className="client-rights">© 2026 Signite Technology Pvt Ltd. All rights reserved.</span>
    </div>
  );
}

export default ClientFooter;